/* Xtrusion F-150 pillar - shared interactions */
(function(){
  if(window.__xtrf150Lib) return; window.__xtrf150Lib=true;
  function init(){
    var hasIO=("IntersectionObserver" in window);
    if(!hasIO){
      document.querySelectorAll(".xtrf150 .reveal").forEach(function(el){el.classList.add("in");});
      document.querySelectorAll(".xtrf150 [data-count]").forEach(function(el){el.textContent=(+el.getAttribute("data-count")).toLocaleString("en-US");});
      return;
    }
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}});},{threshold:.12,rootMargin:"0px 0px -8% 0px"});
    document.querySelectorAll(".xtrf150 .reveal:not(.in)").forEach(function(el){io.observe(el);});
    var co=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;var el=e.target,t=+el.getAttribute("data-count"),s=null,d=1400;function tick(ts){if(!s)s=ts;var pr=Math.min((ts-s)/d,1);el.textContent=Math.floor((1-Math.pow(1-pr,3))*t).toLocaleString("en-US");if(pr<1)requestAnimationFrame(tick);else el.textContent=t.toLocaleString("en-US");}requestAnimationFrame(tick);co.unobserve(el);});},{threshold:.6});
    document.querySelectorAll(".xtrf150 [data-count]").forEach(function(el){co.observe(el);});
    var subnav=document.getElementById("xtrf150-subnav"), hero=document.querySelector(".xtrf150 .hero");
    if(subnav&&hero){var hw=new IntersectionObserver(function(es){es.forEach(function(e){subnav.classList.toggle("show",!e.isIntersecting);});},{threshold:0,rootMargin:"-70px 0px 0px 0px"});hw.observe(hero);}
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",init);
  else init();
})();
